<template>
  <v-container>
    <ComponentPicker
      v-model="value.component"
      title="DataForm"
      :containers="containers"
      :is-required="true"
      type="DataForm"
    />
  </v-container>
</template>

<script>
import ComponentPicker from "../shared/ComponentPicker.vue";

export default {
  name: "DeleteDesigner",

  components: { ComponentPicker },

  props: ["value", "containers"],
};
</script>
